import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "creation__container" }
const _hoisted_2 = { class: "creation__content-wrapper" }
const _hoisted_3 = { class: "creation__content !overflow-visible" }
const _hoisted_4 = { class: "w-full pt-6 xs:pt-12" }
const _hoisted_5 = {
  key: 0,
  class: "text-center flex flex-col gap-8 items-center"
}
const _hoisted_6 = { class: "relative flex justify-center items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-40 h-40",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 92"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "46",
    cy: "46",
    r: "43",
    class: "opacity-0"
  })
], -1)
const _hoisted_8 = { class: "absolute text-8xl leading-none font-bold text-creation-on-background" }
const _hoisted_9 = { class: "h-10 inline-flex items-center font-semibold text-creation-on-background" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col items-center gap-8"
}
const _hoisted_11 = {
  key: 0,
  class: "relative inline-flex self-center"
}
const _hoisted_12 = {
  class: "w-40 h-40 absolute z-10 -rotate-90",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 92"
}
const _hoisted_13 = {
  key: 0,
  class: "text-2xl leading-tight font-bold text-creation-on-background"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full absolute inset-0 z-0 w-full h-full bg-creation-on-background bg-opacity-creation-circle1 creation__circle-1-animation" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full absolute inset-0 z-0 w-full h-full bg-creation-on-background bg-opacity-creation-circle2 creation__circle-2-animation" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-40 h-40 absolute z-10",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 92"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "46",
    cy: "46",
    r: "43",
    class: "stroke-[6] stroke-creation-on-background/creation-separator"
  })
], -1)
const _hoisted_17 = {
  class: "w-40 h-40 absolute z-20 -rotate-90",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 92"
}
const _hoisted_18 = {
  key: 0,
  class: "text-2xl leading-tight font-bold text-creation-on-background text-opacity-creation-medium"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-40 h-40 absolute z-10",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 92"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "46",
    cy: "46",
    r: "43",
    class: "stroke-[6] stroke-creation-on-background/creation-separator"
  })
], -1)
const _hoisted_20 = {
  class: "w-40 h-40 absolute z-10 -rotate-90",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 92"
}
const _hoisted_21 = { class: "text-2xl leading-tight font-bold text-creation-on-background" }
const _hoisted_22 = { class: "flex flex-col gap-4 relative z-10" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#stop" })
], -1)
const _hoisted_24 = {
  key: 1,
  class: "flex gap-3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#trash" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#play" })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#pause" })
], -1)
const _hoisted_28 = { class: "px-4 py-2 xs:py-4 flex justify-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-left" })
], -1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallHeaderComponent = _resolveComponent("SmallHeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SmallHeaderComponent, {
      campaign: _ctx.campaign,
      promptText: _ctx.promptText
    }, null, 8, ["campaign", "promptText"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state === 'countdown')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.timer), 1)
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('creation.recordingCountdownLabel')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.state === 'recording')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args))),
                        id: "record-stop-recording-button",
                        role: "button",
                        tabindex: "0",
                        class: "button button--circle creation__circle-button shadow-md z-10 touch-manipulation"
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_12, [
                          _createElementVNode("circle", {
                            cx: "46",
                            cy: "46",
                            r: "43",
                            class: "creation__progress-circle",
                            style: _normalizeStyle(`--percent: ${_ctx.recordingProgress}`)
                          }, null, 4)
                        ])),
                        (_ctx.state === 'recording')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.recordingTimeLeft), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_14,
                      _hoisted_15
                    ]))
                  : (_ctx.state === 'stopped')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.playAudio && _ctx.playAudio(...args))),
                        role: "button",
                        tabindex: "0",
                        class: "button button--circle creation__circle-button touch-manipulation"
                      }, [
                        _hoisted_16,
                        (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                          _createElementVNode("circle", {
                            cx: "46",
                            cy: "46",
                            r: "43",
                            class: "creation__progress-circle",
                            style: _normalizeStyle(`--percent: ${_ctx.playbackProgress}`)
                          }, null, 4)
                        ])),
                        (_ctx.state === 'playing' || _ctx.state === 'stopped')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.playbackTimeLeft), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.state === 'playing')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pauseAudio && _ctx.pauseAudio(...args))),
                          role: "button",
                          tabindex: "0",
                          class: "button button--circle creation__circle-button"
                        }, [
                          _hoisted_19,
                          (_openBlock(), _createElementBlock("svg", _hoisted_20, [
                            _createElementVNode("circle", {
                              cx: "46",
                              cy: "46",
                              r: "43",
                              class: "creation__progress-circle",
                              style: _normalizeStyle(`--percent: ${_ctx.playbackProgress}`)
                            }, null, 4)
                          ])),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.playbackTimeLeft), 1)
                        ]))
                      : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.state === 'recording')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args))),
                        id: "record-delete-button",
                        class: "button button--secondary bg-creation-background"
                      }, [
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('creation.stopRecordingButtonLabel')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state === 'stopped' || _ctx.state === 'playing')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteAudio && _ctx.deleteAudio(...args))),
                          id: "record-delete-button",
                          class: "button button--secondary"
                        }, [
                          _hoisted_25,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('creation.deleteAudioButtonLabel')), 1)
                        ]),
                        (_ctx.state === 'stopped')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.playAudio && _ctx.playAudio(...args))),
                              class: "button bg-creation-primary text-creation-on-primary touch-manipulation"
                            }, [
                              _hoisted_26,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('creation.playButtonLabel')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.pauseAudio && _ctx.pauseAudio(...args))),
                              class: "button bg-creation-primary text-creation-on-primary touch-manipulation"
                            }, [
                              _hoisted_27,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('creation.pauseButtonLabel')), 1)
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", {
        role: "button",
        tabindex: "0",
        class: "button button--circle button--large button--secondary",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToPromptScreen && _ctx.goToPromptScreen(...args)))
      }, _hoisted_30),
      _createElementVNode("div", {
        role: "button",
        tabindex: "0",
        id: "record-continue-button",
        class: _normalizeClass(["button button--large button--wider shadow bg-creation-primary text-creation-on-primary", { 'button--disabled': !_ctx.canContinue }]),
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.continueToNextScreen && _ctx.continueToNextScreen(...args)))
      }, _toDisplayString(_ctx.$t('creation.continueButtonLabel')), 3)
    ]),
    _createVNode(_component_FooterComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
  ]))
}